module.exports = __webpack_public_path__ + "static/img/19.bded503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/19.png
// module id = 6Mo8
// module chunks = 0